<div class="patient-header-fixed">
    <div class="patient-crumb d-flex justify-content-between align-items-center">
        <span class="patient-crumb-trail d-flex align-items-center">
            <a routerLink="/cdss/dashboard">Dashboard</a>
            <i class="bi bi-chevron-right"></i>
            <a routerLink="/cdss/dashboard">All Patients</a>
            <i class="bi bi-chevron-right"></i>
            <span class="current">{{ currentLabel }}</span>
        </span>
        <a (click)="goBack.emit()" class="patient-crumb-back" style="cursor: pointer;">
            <i class="bi bi-arrow-left"></i> Back
        </a>
    </div>

    <ng-container *ngIf="loading">
        <div class="patient-header d-flex justify-content-between">
            <p class="text-muted mb-0">Loading patient…</p>
        </div>
    </ng-container>

    <ng-container *ngIf="!loading && loadError">
        <div class="patient-header d-flex justify-content-between">
            <p class="text-danger mb-0">Failed to load patient details.</p>
        </div>
    </ng-container>

    <div class="patient-header d-flex justify-content-between" *ngIf="!loading && patient">
        <div class="patient-identity d-flex align-items-center">
            <div class="patient-avatar">{{ initials }}</div>
            <div>
                <div class="patient-name-row d-flex align-items-center">
                    <span class="patient-name">
                        <app-masked-field
                            [value]="displayName"
                            [targetUserId]="targetUserId"
                            fieldName="name">
                        </app-masked-field>
                    </span>
                    <a class="patient-edit-link" [routerLink]="['/cdss/patient-edit', patientId]" aria-label="Edit patient">
                        <i class="bi bi-gear-fill"></i>
                    </a>
                </div>
                <div class="patient-meta">
                    <app-masked-field
                        [value]="displayPhone"
                        [targetUserId]="targetUserId"
                        fieldName="phoneNumber">
                    </app-masked-field>
                    <span class="pill pill-diag" *ngIf="careProgramDiagnosis">{{ careProgramDiagnosis }}</span>
                    <span class="pill pill-role" *ngIf="careProgramRole">{{ careProgramRole }}</span>
                </div>
            </div>
        </div>
        <div class="buttons">
            <ng-content select="[headerActions]"></ng-content>
        </div>
    </div>
</div>
